class FeaturedBlog extends HTMLElement {
  constructor() {
    super();
    window.initLazyScript(this, this.init.bind(this), 500);
  }

  async init() {
    const { url } = this.dataset;
    if (!url) return;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(response.status);

      const tmpl = document.createElement('template');
      tmpl.innerHTML = await response.text();

      const el = tmpl.content.querySelector('featured-blog');
      if (el && el.hasChildNodes()) {
        this.innerHTML = el.innerHTML;
        this.classList.remove('featured-blog--loading');
      }
    } catch (error) {
      console.log(error); // eslint-disable-line
      this.classList.remove('featured-blog--loading');
    }
  }
}

customElements.define('featured-blog', FeaturedBlog);
